import type { IconNode } from 'lucide-react'
import { createLucideIcon } from 'lucide-react'

// eslint-disable-next-line react-refresh/only-export-components, @typescript-eslint/naming-convention
export const __iconNode: IconNode = [
	[
		'path',
		{
			d: 'M22 16.92V19.92C22.0011 20.1985 21.9441 20.4741 21.8325 20.7293C21.7209 20.9845 21.5573 21.2136 21.3521 21.4018C21.1468 21.5901 20.9046 21.7335 20.6407 21.8227C20.3769 21.9119 20.0974 21.945 19.82 21.92C16.7428 21.5856 13.787 20.5341 11.19 18.85C8.77382 17.3146 6.72533 15.2661 5.18999 12.85C3.49997 10.2412 2.44824 7.27097 2.11999 4.17997C2.095 3.90344 2.12787 3.62474 2.21649 3.3616C2.30512 3.09846 2.44756 2.85666 2.63476 2.6516C2.82196 2.44653 3.0498 2.28268 3.30379 2.1705C3.55777 2.05831 3.83233 2.00024 4.10999 1.99997H7.10999C7.5953 1.9952 8.06579 2.16705 8.43376 2.48351C8.80173 2.79996 9.04207 3.23942 9.10999 3.71997C9.23662 4.68004 9.47144 5.6227 9.80999 6.52997C9.94454 6.8879 9.97366 7.27689 9.8939 7.65086C9.81415 8.02482 9.62886 8.36809 9.35999 8.63998L8.08999 9.90997C9.51355 12.4135 11.5864 14.4864 14.09 15.91L15.36 14.64C15.6319 14.3711 15.9751 14.1858 16.3491 14.1061C16.7231 14.0263 17.1121 14.0554 17.47 14.19C18.3773 14.5285 19.3199 14.7634 20.28 14.89C20.7658 14.9585 21.2094 15.2032 21.5265 15.5775C21.8437 15.9518 22.0122 16.4296 22 16.92Z',
			key: 'ipd-phone-ringing-path-0',
		},
	],
	[
		'path',
		{
			d: 'M16.1097 7.68041L19.4622 4.60479',
			key: 'ipd-phone-ringing-path-1',
		},
	],
	[
		'path',
		{
			d: 'M14.2228 6.23814L15.9589 1.99999',
			key: 'ipd-phone-ringing-path-2',
		},
	],
	[
		'path',
		{
			d: 'M17.5585 9.40827L21.8769 8.09273',
			key: 'ipd-phone-ringing-path-3',
		},
	],
]

const IpdPhoneRinging = createLucideIcon('ipd-phone-ringing', __iconNode)
export default IpdPhoneRinging
